import React from 'react';
import { Container } from 'amphitheatre';

import Content from './FAQ.content';

function FAQ(): React.ReactElement {
  return (
    <Container className="content-container" size="lg">
      <Content />
    </Container>
  );
}

export default FAQ;
